import { jsx as _jsx } from "react/jsx-runtime";
import { assoc, dissoc } from 'ramda';
import { createContext, useCallback, useContext, useState, } from 'react';
import { devError } from '../utils';
export const RefsContext = createContext({
    refs: {},
    setRef: () => devError('RefsContext not initialized! Use RefsProvider to able to use ref hooks.'),
});
export function useFieldRef(key) {
    const { setRef } = useContext(RefsContext);
    const callback = useCallback((current) => setRef(key, current), [setRef, key]);
    return callback;
}
export function useGetRef(key) {
    const { refs } = useContext(RefsContext);
    return key !== null ? refs[key] : null;
}
export function RefsProvider({ children }) {
    const [refs, setRefs] = useState({});
    // set or unset a ref
    const setRef = useCallback((key, ref) => {
        if (ref === null) {
            setRefs((refs) => dissoc(key, refs));
        }
        else {
            setRefs((refs) => assoc(key, ref, refs));
        }
    }, []);
    return (_jsx(RefsContext.Provider, { value: { refs, setRef }, children: children }));
}
